import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "This interactive element shows the direct and possible flanking transmission paths between source and receiving rooms.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          items: [
            { name: "Direct path" },
            { name: "Flanking transmisison partly through floor  and considered wall" },
            { name: "Flanking transmisison through side wall" },
            { name: "Flanking transmisison through side wall and considered wall" },
            { name: "Flanking transmisison through floor" },
          ],
          options: {
            label: "Type of sources",
            labelPosition: "left",
          },
        },
      ],
      extraContent: [[], [], [], [], []],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/16/principle/direct-path.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/16/principle/floor-and-considered-wall.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/16/principle/side-wall.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/16/principle/side-wall-and-considered-wall.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/16/principle/floor.svg`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
